import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import profilesReducer from './slices/profilesSlice';
import integrationsReducer from './slices/integrationsSlice';
import cveFieldsReducer from './slices/cveFieldsSlice'
import previousRouteReducer from './slices/previousRouteSlice'
import technologiesReducer from './slices/technologiesSlice';
import contextureMetadataReducer from './slices/contextureMetadataSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profilesReducer,
    integrations: integrationsReducer,
    cveFields: cveFieldsReducer,
    previousRoute: previousRouteReducer,
    technologies: technologiesReducer,
    contextureMetadata: contextureMetadataReducer,
  },
});
